/**
 * Israel timezone date utilities for ATM business logic.
 *
 * Business rule: After 18:00 Israel time, the "business date" rolls forward to tomorrow.
 * This is used for loading terminal calculations and employee activity screens.
 */

/**
 * Returns the current hour in Israel timezone (0-23).
 * @returns {number}
 */
export const getIsraelCurrentHour = () => {
  const now = new Date();
  const israelTime = now.toLocaleTimeString('en-US', {
    timeZone: 'Asia/Jerusalem',
    hour12: false,
  });
  return parseInt(israelTime.split(':')[0], 10);
};

/**
 * Returns today's date, or tomorrow if it's after 18:00 Israel time.
 * Used as the default date for loading terminal and employee activity screens.
 * @returns {Date}
 */
export const getIsraelBusinessDate = () => {
  const now = new Date();
  const currentHour = getIsraelCurrentHour();
  if (currentHour >= 18) {
    const tomorrow = new Date(now);
    tomorrow.setDate(now.getDate() + 1);
    return tomorrow;
  }
  return now;
};
